/**
 * Updates view toggle link hrefs to preserve existing URL parameters when switching views.
 * Runs in connectedCallback so it re-executes after AJAX section re-renders.
 */
class ViewToggleComponent extends HTMLElement {
  connectedCallback() {
    for (const link of this.querySelectorAll('[data-view]')) {
      if (!(link instanceof HTMLAnchorElement)) continue;
      const url = new URL(window.location.href);
      const view = link.dataset.view;
      if (view === 'grid') {
        url.searchParams.delete('view');
      } else {
        url.searchParams.set('view', view);
      }
      link.href = url.toString();
    }
  }
}

if (!customElements.get('view-toggle-component')) {
  customElements.define('view-toggle-component', ViewToggleComponent);
}
